import React from 'react';
import { connect } from 'react-redux';
import Icon from 'views/Icon';
import classnames from 'classnames';
import Rupee from 'views/Rupee';
import Animate from 'views/Animate';
import {
  rupees,
} from 'config/utils';

class ConvenienceFeesAccordion extends React.Component {
  constructor () {
    super();
    this.state = {
      isOpen: false,
    };
  }

  render () {
    const {
      showConvenienceFee,
      isFinalizeFormOpen,
      finalizePurchase: {
        selectedPaymentMode,
        selectedPaymentObject: {
          convenienceFeesAndTax,
          convenienceFeesTax,
          convenienceFees,
          totalAmount,
        } = {},
      },
    } = this.props;

    const {
      isOpen,
    } = this.state;
    return (
      showConvenienceFee && selectedPaymentMode && isFinalizeFormOpen ?
      <div className="push-half--top" className="text-light-grey">
        <div
          className="soft-half--top"
          onClick={() => this.setState({ isOpen: !isOpen })}>
          <Icon className={classnames('sm',
              isOpen ? 'arrows-1_minimal-down'  : 'arrows-1_minimal-right')
            } />
          <span>Convenience Fee</span>
          { !isOpen ?
            <span
              className="right">
              <Rupee value={rupees(convenienceFeesAndTax)} />
            </span> :
            null
          }
        </div>
        { isOpen ?
          <Animate
            style={{ marginLeft: '17px' }}>
            <div className="soft-half--top">
              <span>Processing Fee</span>
              <span className="right">
                <Rupee value={rupees(convenienceFees)} />
              </span>
            </div>
            <div className="soft-half--top">
              <span>Applicable Taxes</span>
              <span className="right">
                <Rupee value={rupees(convenienceFeesTax)} />
              </span>
            </div>
          </Animate> :
          null
        }
        <div
          className="push--top text-black"
          style={{
            paddingTop: '10px',
            paddingBottom: '4px',
            borderTop: '1px solid rgba(227, 236, 242, 0.498039)',
          }
        }>
          <span>
            Total
          </span>
          <span className="right">
            <Rupee value={rupees(totalAmount)} />
          </span>
        </div>
      </div> :
      null
    );
  }
}

const mapStateToProps = ({
  cart,
  settings,
  retry,
  finalizePurchase,
}) => {
  if (cart) {
    return {
      showConvenienceFee: cart.settings.showConvenienceFee,
      finalizePurchase: cart.finalizePurchase,
      isFinalizeFormOpen: cart.openTab === 'PAYMENT',
    };
  }
  else if (settings.isRetrying) {
    return {
      showConvenienceFee: settings.showConvenienceFee,
      finalizePurchase: retry.finalizePurchase,
      isFinalizeFormOpen: settings.isFinalizeFormOpen,
    };
  }

  return {
    showConvenienceFee: settings.showConvenienceFee,
    finalizePurchase,
    isFinalizeFormOpen: settings.isFinalizeFormOpen,
  };
};

export default connect(mapStateToProps)(ConvenienceFeesAccordion);



// WEBPACK FOOTER //
// ./src/payments/views/convenience-fee/ConvenienceFeesAccordion.js